/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import React, { MouseEventHandler } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { PropTypes } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    primaryButton: {
        margin: '0 0 5px 10px',
        textTransform: 'capitalize',
        borderRadius: '5px',
        fontSize: '11px',
    }
}));

interface PrimaryButtonProps {
    buttonLabel?: string,
    onClick?: MouseEventHandler,
    startIcon?: React.ReactNode,
    className?: string,
    type?: 'submit' | 'reset' | 'button',
    color?: PropTypes.Color,
    id?: string,
    dataTestId?: string,
    disabled?: boolean,
}

function PrimaryButton(props: PrimaryButtonProps) {
    const classes = useStyles();

    const primaryButtonLabel = props.buttonLabel;
    const handlePrimaryButtonClick = props.onClick;
    // Allow to add an icon and any custom modifications
    const { startIcon, className, type, color, id, dataTestId, disabled } = props;

    return (
        <Button
            variant="contained"
            color={color || "primary"}
            disableElevation
            classes={{ root: classes.primaryButton }}
            className={className}
            onClick={handlePrimaryButtonClick}
            startIcon={startIcon}
            type={type}
            id={id}
            disabled={disabled}
            data-testid={dataTestId || id}
        >
            {primaryButtonLabel}
        </Button>
    )
}

export default PrimaryButton;
